{
  "titles": {
    "join": "Join {{fboName}}",
    "invalidInvite": "Invalid Invite"
  },
  "messages": {
    "joinQuestion": "Do you want to join {{fboName}} on AirPlx?",
    "alreadyClaimed": "You have already claimed your invite. You can now access your account at app.airplx.com. We recommend bookmarking the link in your browser for quick access going forward."
  },
  "buttons": {
    "no": "No",
    "yes": "Yes",
    "ok": "Ok"
  }
}
